"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.define-property.js");

var _react = _interopRequireDefault(require("react"));

require("./TreeContextMenu.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TreeContextMenu = /*#__PURE__*/_react.default.memo(function (_ref) {
  var overlay = _ref.overlay,
      node = _ref.node,
      xPos = _ref.xPos,
      yPos = _ref.yPos,
      _ref$showMenu = _ref.showMenu,
      showMenu = _ref$showMenu === void 0 ? false : _ref$showMenu;
  //calculate the visibility to show/hide the context menu
  var visibility = showMenu ? {
    visibility: 'visible'
  } : {
    visibility: 'hidden',
    height: 0
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    mode: "vertical",
    className: "rolext-tree-context-menu",
    style: _objectSpread(_objectSpread({}, visibility), {}, {
      top: yPos,
      left: xPos
    }),
    children: overlay
  });
});

var _default = TreeContextMenu; // const ContextMenu = ({ menu }) => {
//     const { xPos, yPos, showMenu } = useContextMenu();
//     return (
//       <Motion
//         defaultStyle={{ opacity: 0 }}
//         style={{ opacity: !showMenu ? spring(0) : spring(1) }}
//       >
//         {(interpolatedStyle) => (
//           <>
//             {showMenu ? (
//               <div
//                 className="menu-container"
//                 style={{
//                   top: yPos,
//                   left: xPos,
//                   opacity: interpolatedStyle.opacity,
//                 }}
//               >
//                 {menu}
//               </div>
//             ) : (
//               <></>
//             )}
//           </>
//         )}
//       </Motion>
//     );
//   };

exports.default = _default;